import styled from 'styled-components';

export const ThumbnailPopoverElement = styled.div`
    width: 150px;
    padding: 10px;
`;

export const UpdateModuleContainer = styled.div`
    padding:20px;

    .wrapper{
        display: flex;
        flex-direction: column;
        gap: 40px;

        .textareaBox{
            textarea{
                height: 100px;
            }

            .counter{
                font-size: 10px;
                margin-top: 5px;
                padding-right: 20px;
                text-align: right;
                font-weight: 600;
            }
        }

        .wrapper__selectBox{
            position: relative;
            label {
                position: absolute;
                top: -20px;
                left: 20px;
                transition: top 0.3s, left 0.3s;
                pointer-events: none;
                font-size: 12px;
                color: #606060;
                font-weight: 500;
            }

            select{
                border-radius: 15px;
                height: 50px;
                border: 1.5px solid #00000000;
                background-color: var(--defaultElementBC);
                padding: 0 20px;
                font-weight: 700;
                &:focus{
                    border-color: #000000;
                }
            }
        }

        .wrapper__footerButtonGroup{
            display: flex;
            gap: 10px;

            button{
                padding: 0 16px;
                border-radius: 30px;
                height: 50px;
                background-color: #111827;
                border: none;
                font-size: 16px;
                font-weight: 700;
                color: #fff;

                &:hover{
                    background-color: #374151;
                }
            }
        }
    }
`;